module.exports = __webpack_public_path__ + "/login_ui/img/na-c98ec4d43145c34a19c488962a72143d.svg";